// Chakra imports
import { Box, Flex } from "@chakra-ui/react";
// Custom components
import Numbers from "sections/numbers";
import Services from "sections/services";
import Portfolio from "sections/portfolio";
import Hero from "sections/hero";
// import CTA from "sections/cta";
import { Helmet } from "react-helmet-async";
import Testimonials from "sections/testimonials";
import Contact from "sections/contact";
export default function Default() {
	return (
		<>
			<Helmet>
				<title>Horizon UI Custom Development - Work with us</title>
				<link
					rel='canonical'
					href='https://horizon-ui.com/custom-development'
				/>
				<meta
					name='description'
					content='Discover the full capabilities of the Horizon UI products & library with our team of experts ready to support you in building, scaling, and customizing SaaS applications, e-commerce sites, and administrative dashboards.'
				/>
				<meta
					name='title'
					content='Horizon UI Custom Development - Work with us'
				/>
				<meta
					itemprop='title'
					content='Horizon UI Custom Development - Work with us'
				/>
				<meta
					itemprop='name'
					content='Horizon UI Custom Development - Work with us'
				/>
				<meta
					itemprop='description'
					content='Discover the full capabilities of the Horizon UI products & library with our team of experts ready to support you in building, scaling, and customizing SaaS applications, e-commerce sites, and administrative dashboards.'
				/>

				<meta
					itemprop='image'
					content='https://i.ibb.co/cXwPXzw/Meta-image-Horizon-UI-Custom-dev.png'
				/>

				<meta name='twitter:card' content='summary_large_image' />
				<meta name='twitter:site' content='@horizon_ui' />
				<meta
					name='twitter:title'
					content='Horizon UI Custom Development - Work with us'
				/>

				<meta
					name='twitter:description'
					content='Discover the full capabilities of the Horizon UI products & library with our team of experts ready to support you in building, scaling, and customizing SaaS applications, e-commerce sites, and administrative dashboards.'
				/>
				<meta name='twitter:creator' content='@horizon_ui' />
				<meta
					name='twitter:image'
					content='https://i.ibb.co/cXwPXzw/Meta-image-Horizon-UI-Custom-dev.png'
				/>
				<meta
					property='og:title'
					content='Horizon UI Custom Development - Work with us'
				/>
				<meta property='og:type' content='summary_large_image' />
				<meta
					property='og:url'
					content='https://horizon-ui.com/custom-development/'
				/>
				<meta
					property='og:image'
					content='https://i.ibb.co/cXwPXzw/Meta-image-Horizon-UI-Custom-dev.png'
				/>
				<meta
					property='og:description'
					content='Discover the full capabilities of the Horizon UI products & library with our team of experts ready to support you in building, scaling, and customizing SaaS applications, e-commerce sites, and administrative dashboards.'
				/>
				<meta
					property='og:site_name'
					content='Horizon UI Custom Development - Work with us'
				/>
			</Helmet>
			<Flex direction={{ base: "column" }} overflowX='hidden'>
				<Hero />
				<Numbers />
				<Services />
				<Box id='projects'>
					<Portfolio />
				</Box>
				<Testimonials />
				<Box id='form'>
					<Contact />
				</Box>
			</Flex>
		</>
	);
}
